import type { BuildingIfcViewerSections } from "../../../types/buildings-sections/ifc-viewer";

export const ifcViewer: BuildingIfcViewerSections = {
  // Page shell
  loadingModels: "3D mudelite laadimine…",
  loadModelsFailed: "Selle hoone IFC mudelite laadimine ebaõnnestus.",
  noModelsTitle: "3D mudeleid pole veel",
  noModelsBodyPrefix: "Laadi üles",
  noModelsBodySuffix:
    "fail dokumentide vahelehelt, et seda vaadet täita. Töötlus eraldab 3D geomeetria ja struktureeritud hooneandmed.",
  goToDocuments: "Mine dokumentide juurde",

  // Canvas
  loadingModel: "3D mudeli laadimine…",
  selectModelPrompt: "Vali mudel, et seda 3D-s vaadata.",
  noSpatialStructure: "Sellel IFC-failil pole kuvatavat ruumistruktuuri.",
  loadSceneFailed: "3D stseeni laadimine ebaõnnestus",
  noGeometryTitleSuffix: "ei sisalda 3D geomeetriat",
  noGeometryDescription: "Mudel jäeti 3D vaates vahele.",

  // Model picker
  selectModels: "Vali mudelid",
  browseAllModels: "Sirvi kõiki {count} IFC faile",
  sectionSelected: "Valitud",
  sectionRecent: "Hiljutised",
  sectionLatestUploads: "Viimati lisatud",
  browseModelsTitle: "Sirvi mudeleid",
  oneModelPrefix: "1 mudel:",
  modelsCountSuffix: "mudelit",
  compareDifferences: "Võrdle erinevusi",
  compareSelectTwoVersions: "Võrdlemiseks vali täpselt kaks versiooni",
  applySelection: "Rakenda",
  elementsCountSuffix: "elementi",
  loadToToggleVisibility: "Nähtavuse muutmiseks laadi see mudel",
  hideInView: "Peida 3D vaates",
  showInView: "Näita 3D vaates",
  showVersions: "Näita vanemaid versioone",
  hideVersions: "Peida vanemad versioonid",
  versionPickerLabel: "Versioon",

  // Toolbar
  fitToModel: "Mahuta mudel vaatesse",
  downloadScreenshot: "Laadi ekraanipilt alla",
  birdsEyeView: "Linnulennuvaade",
  sideViewCycles: "Külgvaade (vahetab 4 külje vahel)",
  sectionBoxLabel: "Lõikekast (kõrgus- ja lõikevaated)",
  spatialStructure: "Ruumistruktuur",
  modelIssuesTitle: "Mudeliga seotud ülesanded",
  showControls: "Näita juhtnuppe",
  hideControls: "Peida juhtnupud",

  // Discipline filter (WHA-3729)
  filtersLabel: "Filtrid",
  filtersTitle: "Filtrid",
  filtersEmpty: "Mudelit pole laaditud",
  filterNoOptions: "Pole midagi filtreerida",

  // Nav cluster
  moveForward: "Liigu edasi",
  moveBack: "Liigu tagasi",
  moveLeft: "Liigu vasakule",
  moveRight: "Liigu paremale",
  zoomIn: "Suumi sisse",
  zoomOut: "Suumi välja",
  scrollUp: "Keri üles",
  scrollDown: "Keri alla",
  showNavigation: "Näita navigeerimist",
  hideNavigation: "Peida navigeerimine",
  dragRotateScrollZoom: "Lohista pööramiseks · Keri suumimiseks",

  // Spatial tree
  treeEmptyPrompt: "Ruumistruktuuri nägemiseks laadi mudel valijast.",
  loadingTree: "Ruumistruktuuri laadimine…",
  loadTreeFailedPrefix: "Laadimine ebaõnnestus:",
  noSpatialData: "Ruumiandmed puuduvad.",
  loadingShort: "Laadimine…",
  loadElementsFailed: "Elementide laadimine ebaõnnestus.",
  expand: "Laienda",
  collapse: "Ahenda",

  // Property panel
  propEmptyPrompt: "Omaduste nägemiseks klõpsa elemendil 3D vaates või puus.",
  loadingProperties: "Omaduste laadimine…",
  loadPropertiesFailed: "Omaduste laadimine ebaõnnestus.",
  elementWord: "Element",
  noElementData: "Selle elemendi kohta andmed puuduvad.",
  fromModel: "Allikas",
  layerWord: "kiht",
  materialsHeader: "Materjalid",
  propType: "Tüüp",
  propName: "Nimi",
  propLongName: "Pikk nimi",
  propGuid: "GUID",
  propElevation: "Kõrgus",
  unnamed: "(nimetu)",
  noProperties: "Sellel elemendil pole omadusi.",
  propertySingular: "omadus",
  propertyPlural: "omadust",
  materialSingular: "materjal",
  materialPlural: "materjali",
  yes: "Jah",
  no: "Ei",
  value: "Väärtus",

  // Section panel
  sectionBoxTitle: "Lõikekast",
  snapToFloors: "Joonda korrustega",
  snapToFloorsTooltip: "Joonda kõrguslõige tuvastatud korruste tasemetega",
  resetBox: "Lähtesta kast",
  resetBoxTooltip: "Lähtesta kast kogu mudelile",
  clearSection: "Eemalda lõige",
  clearSectionTooltip: "Eemalda lõige — taasta terve mudel",
  clearFilters: "Eemalda filtrid",
  hideSectionPanelTooltip: "Peida paneel — lõige jääb alles",
  elevationCut: "Kõrguslõige (kõrgus)",
  sectionWidth: "Lõige (laius)",
  sectionDepth: "Lõige (sügavus)",
  topView: "Pealtvaade",
  sideView: "Külgvaade",
  frontView: "Eestvaade",
  close: "Sulge",
  minimize: "Minimeeri",
  suspendSection: "Peata lõige",
  suspendSectionTooltip: "Peata lõige — näed tervet mudelit, lõige säilib",
  resumeSection: "Jätka lõiget",
  resumeSectionTooltip: "Taasta lõige",
  showSectionHandles: "Näita pidemeid",
  hideSectionHandles: "Peida pidemed",
  isolateStorey: "Eralda korrus",
  isolateStoreyTooltip: "Piira lõikekast ühele korrusele",
  wholeBuilding: "Kogu hoone",
  customCut: "Kohandatud",
  obliqueCuts: "Kaldlõiked",
  obliqueCutFallbackLabel: "Lõige",
  removeCut: "Eemalda lõige",
  boundMinLabel: "{axis} — alumine piir meetrites",
  boundMaxLabel: "{axis} — ülemine piir meetrites",

  // Context menu
  createIssue: "Loo ülesanne",
  takeScreenshot: "Tee ekraanipilt",
  highlightSimilar: "Tõsta esile sarnased elemendid",
  cutHere: "Lõika siit",
  sectionBoxAroundThis: "Lõikekast ümber selle",

  // Issue panels
  propertiesTitle: "Omadused",
  elementIssuesTitle: "Elemendi ülesanded",
  elementIssuesEmpty: "Selle elemendiga pole veel ühtegi ülesannet seotud.",
  modelIssuesEmpty: "Selle mudeliga pole veel ühtegi ülesannet seotud.",
  issuesLoadFailed: "Mudeli ülesannete laadimine ebaõnnestus.",
  createIssueFromElement: "Loo sellest elemendist ülesanne",
  expandIssue: "Ava ülesanne",
  goToElement: "Mine elemendi juurde",
  restoreViewpoint: "Taasta salvestatud vaade",
  viewpointUnsupported: "See salvestatud vaade on loodud Franklini uuema versiooniga.",
  viewpointModelsGone: "Mudelid, millega see vaade salvestati, ei ole enam saadaval.",
  viewpointModelsPartial: "Osa selle vaate mudelitest ei ole enam saadaval.",
  viewpointElementGone: "Seotud elementi selles mudelis enam ei ole — vaade taastati ilma selleta.",
  viewpointRestoreFailed: "Salvestatud vaate taastamine ebaõnnestus.",

  noData: "Andmed puuduvad",

  // Issue → element links
  unlinkElementFailedTitle: "Elemendi seose eemaldamine ebaõnnestus",
  tryAgain: "Palun proovi uuesti.",
  unlinkElement: "Eemalda elemendi seos",
  openIn3dTitle: "Kas avada 3D vaaturis?",
  viewElementDescPrefix: "Kas vaadata elementi ",
  viewElementDescSuffix: " 3D vaaturis? Mudel avaneb koos selle valitud elemendiga.",
  openViewer: "Ava vaatur",

  // Document-preview IFC confirm
  openBimModelQuestion: "Kas avada see BIM mudel 3D vaaturis?",
  noBuildingForModel: "Sellel mudelil pole seotud hoonet, mistõttu ei saa seda 3D vaaturis avada.",
  open3dModel: "Ava 3D mudel",
  closeViewer: "Sulge vaade",
  previewLoading: "Eelvaate laadimine…",
  previewUnavailable: "3D eelvaade pole veel saadaval",

  // Version comparison / diff (WHA-3695)
  compareExit: "Lõpeta võrdlus",
  compareSwap: "Vaheta vanem / uuem",
  compareLoading: "Erinevuste arvutamine…",
  compareFailed: "Mudelite võrdlemine ebaõnnestus.",
  compareChangesTitle: "Muudatused",
  compareMetricsTitle: "Näitajad",
  compareNoChanges: "Need kaks mudelit on identsed — erinevusi ei leitud.",
  compareSelectPrompt: "Vali muudetud element, et näha, mis muutus.",
  changeAdded: "Lisatud",
  changeRemoved: "Eemaldatud",
  changeModified: "Muudetud",
  changeUnchanged: "Muutmata",
  changedProperty: "omadus",
  changedMaterial: "materjal",
  changedAttribute: "atribuut",
  diffBefore: "Enne",
  diffAfter: "Pärast",
  diffPropertiesHeader: "Omadused ja mõõdud",
  diffMaterialsHeader: "Materjalid",
  diffAttributesHeader: "Atribuudid",
  diffAttrStorey: "Korrus",
  diffAttrParent: "Asukoht struktuuris",
  diffNoDetail: "Omaduste ega materjalide erinevusi pole.",
  diffLoadingDetail: "Erinevuste laadimine…",
  diffCloseDetail: "Sulge üksikasjad",
  diffChangeFile: "Vaheta fail",
  diffSearchFiles: "Otsi faile…",
  diffNoFiles: "Muid IFC-faile pole",
  diffOlderVersions: "Vanemad versioonid",

  // Diff UI overhaul (WHA-3695 follow-up)
  diffOverviewTitle: "Erinevuste ülevaade",
  openIn3dViewer: "Ava 3D vaaturis",
  compareSummaryTitle: "Kokkuvõte",
  noOverlapInsight:
    "Neil kahel mudelil pole ühiseid elemente — tõenäoliselt eri erialad või hooned, mitte sama mudeli kaks versiooni.",
  groupByLabel: "Rühmita",
  groupByClass: "Klass",
  groupByStorey: "Korrus",
  groupByDiscipline: "Distsipliin",
  disciplineIncludes: "Sisaldab",
  disciplineOtherHint: "Elemendid, mida pole distsipliinile määratud.",
  diffSearchPlaceholder: "Otsi elemente…",
  unassignedStorey: "Korruseta",
  isolateChanges: "Eralda muudatused",
  diffShowingOf: "kuvatud {shown} / {total}",
  diffInThreeD: "{shown} / {total} 3D-vaates",
  diffNotIn3d: "Pole 3D-s",
  diffGeometryNote: "{drawable} / {total} muudatust 3D-vaates",
  diffGeometryNoteTooltip:
    "Kas muudatus ilmub 3D-s, oleneb mudeli tegelikust geomeetriast. Avadel ja tühimikel, tehnosüsteemide portidel ning muudel kehata elementidel pole geomeetriat, seega loevad nad muudatustena, kuid neid ei saa 3D-vaates kuvada.",
  compareModelNewer: "Uuem",
  compareModelOlder: "Vanem",
  renderFilterLabel: "Renderdusfilter",
  filterFloor: "Korrus",
  filterDiscipline: "Distsipliin",
  filterClass: "Klass",
  filterSpaces: "Näita ruume",
  filterClear: "Tühjenda",
  metricStoreys: "Korrused",
  metricSpaces: "Ruumid",
  metricElements: "Elemendid",
  metricMaterials: "Materjalid",
  metricGrossArea: "Brutopind (m²)",
  metricVolume: "Maht (m³)",
};
